import { TranslatableText } from 'state/types'
import { SUPRA_MAINNET_CHAIN_ID, SUPRA_TESTNET_CHAIN_ID } from './chains'

export type IfoStatus = 'idle' | 'coming_soon' | 'live' | 'finished'

export interface Ifo {
  id: string
  isActive: boolean
  isPrivate: boolean
  address: string
  name: string
  subTitle?: string
  // Shown under the name on the sale's page; a blank line starts a new paragraph
  description?: string
  launchDate: string
  launchTime: string
  // Sale window in unix seconds; it drives the status and countdown, so keep it in step with launchDate/launchTime
  startTime: number
  endTime: number
  saleAmount: string
  raiseAmount: string
  // Raise goal in whole currency units (30000 = 30,000 USDC), used instead of reading the sale contract's raisingAmount
  raisingAmount?: number
  cakeToBurn: string
  projectSiteUrl: string
  telegramUrl?: string
  xUrl?: string
  currency: string
  currencyAddress: string
  currencyDecimals: number
  tokenDecimals: number
  tokenSymbol: string
  releaseTime: number
  campaignId?: string
  maxDepositAmount?: number
  vestingPercentage?: number
  // The goal is a soft cap and all the tokens for sale are shared across the deposits (the TOON sale). Otherwise the
  // sale has the fixed price IDO.sol charges: goal ÷ tokens for sale.
  isFairLaunch?: boolean
}

export enum PoolCategory {
  'COMMUNITY' = 'Community',
  'CORE' = 'Supra',
}

export interface Address {
  [SUPRA_TESTNET_CHAIN_ID]?: string
  [SUPRA_MAINNET_CHAIN_ID]: string
}

export interface Token {
  symbol: string
  address?: Address
  decimals?: number
  projectLink?: string
}

export interface FarmConfig {
  pid: number
  lpSymbol: string
  lpAddresses: Address
  token: Token
  quoteToken: Token
  multiplier?: string
  // Allocation points the add-pool script gives this pool; the farm shows them until its pool is on the MasterChef
  plannedAllocPoint?: number
  isCommunity?: boolean
  dual?: {
    rewardPerBlock: number
    earnLabel: string
    endBlock: number
  }
}

export interface VaultConfig {
  pid: number
  lpSymbol: string
  lpAddresses: Address
  vaultAddresses: Address
  strategyAddresses: Address
  stratxAddress?: Address
  token: Token
  quoteToken?: Token
  ftoken?: Token
  provider?: string
  multiplier?: string
  isCommunity?: boolean
  isSingle?: boolean
  dual?: {
    rewardPerBlock: number
    earnLabel: string
    endBlock: number
  }
}

export interface PoolConfig {
  sousId: number
  earningToken: Token
  stakingToken: Token
  stakingLimit?: number
  contractAddress: Address
  poolCategory: PoolCategory
  tokenPerSecond: string
  sortOrder?: number
  harvest?: boolean
  isFinished?: boolean
  depositFee?: number
}

export type Images = {
  lg: string
  md: string
  sm: string
  ipfs?: string
}

export type NftImages = {
  blur?: string
} & Images

export type NftVideo = {
  webm: string
  mp4: string
}

export type Nft = {
  name: string
  description: string
  images: NftImages
  sortOrder: number
  bunnyId: number
  video?: NftVideo
}

export type TeamImages = {
  alt: string
} & Images

export type Team = {
  id: number
  name: string
  description: string
  isJoinable?: boolean
  users: number
  points: number
  images: TeamImages
  background: string
  textColor: string
}

export type CampaignType = 'ifo'

export type Campaign = {
  id: string
  type: CampaignType
  title?: TranslatableText
  description?: TranslatableText
  badge?: string
}
